import { types, actions } from './requests'
export const CREATEARTICLE_TYPES = {
    ...types('CREATEARTICLE'),
}
export const CREATEARTICLE_ACTIONS = {
    ...actions('CREATEARTICLE'),
}
